import { Injectable } from '@angular/core';

import { ERoutes } from '../enums/routes.enum';
import { IWhitelabel } from '../interfaces/whitelabel';
import { WHITE_LABELS } from '../../shared/constants/whitelabel.const';
import { EDomainCurrency, EDomainCurrencySymbol } from '../enums/domain.enum';

import { SsrHelperService } from './ssr-helper.service';
import { ApiSettingsService } from './api-settings.service';

@Injectable({
  providedIn: 'root',
})
export class DomainTrackingService {
  private _whitelabel: IWhitelabel | null = null;

  constructor(
    private apiSettings: ApiSettingsService,
    private ssrHelperService: SsrHelperService,
  ) {}

  set whitelabel(whitelabel: IWhitelabel) {
    this._whitelabel = whitelabel;
  }

  get whitelabel(): IWhitelabel | null {
    return this._whitelabel;
  }

  checkIfIsWhitelabel(): boolean {
    if (this.ssrHelperService.userAgent) {
      WHITE_LABELS.some((whitelabel: IWhitelabel) => {
        if (document.documentURI.includes(whitelabel.countryName)) {
          this.whitelabel = whitelabel;
          return true;
        }

        return false;
      });
    }

    return !!this.whitelabel;
  }

  getPostLogoutRoute(): string {
    return this.checkIfIsWhitelabel() ? ERoutes.TRIP_PLANNER : ERoutes.EMPTY;
  }

  getCurrency(): string {
    if (this.whitelabel) {
      return this.whitelabel.currency;
    }
    if (this.apiSettings.currency) {
      return this.apiSettings.currency;
    }
    return EDomainCurrency.OTHER_COUNTRY;
  }

  getCurrencySymbol(): string {
    if (this.whitelabel) {
      return this.whitelabel.currencySymbol;
    }

    if (this.apiSettings.currency) {
      return this.apiSettings.currencySymbol;
    }

    return EDomainCurrencySymbol.OTHER_COUNTRY;
  }
}
